<template>
    <div class="productcategory">
        <div class="category pl-2 mt-4">
            <h3 class="ui header medium-lg small-md tiny-sm color pt-2">{{$t('Categories')}}</h3>
            <div  class="ui accordion js-accordion">
                <div v-for="(category,i) in categorys" :key=" 'category'+i "  >
                    <div class="title">
                        <a @click="activeMenu('category'+i , category)" :class="{ 'active' : menuActive == 'category'+i }" class="ui  text large-lg medium-md tiny-sm mini light d-inline-block mt-2">
                            <span class="color category">{{category.name}}</span>
                            <span v-if="category.amount > 0" class="color gray-7">({{category.amount}})</span>
                        </a>
                    </div>
                    <div v-if="category.childrens.length > 0" class="content  pl-2">
                        <div class="ui bulleted list">
                            <a v-for="(subCategory,ii) in category.childrens" :key=" 'subCategory'+ ii " 
                                :class="{ 'active' : subMenuActive == 'subCategory'+ii }"
                                @click="selectCategory(subCategory,'subCategory'+ii)"
                                class="item ui text medium-md tiny-sm mini light  mt-1 mb-1">
                                <span class="color black category">{{subCategory.name}}</span>
                            </a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'productcategory',
    components: {},
    props: {
    },
    data () {
        return {
            categorys : null,
            menuActive: null,
            subMenuActive: null,
        }
    },
    computed: {},
    created () {
        this.$http
            .get('categories')
            .then(response => {
                this.categorys = response.data.data
            })
            .catch(error => console.log(error))
    },
    methods: {
        activeMenu(menu,category){
            this.subMenuActive = null
            this.menuActive = menu  
            this.$parent.categoryName = category.name
            this.$router.push({
                name: 'product', 
                query: {
                    search: category.name
                }
            })
        },
        selectCategory(subCategory,subMenuActive){
            console.log(subMenuActive)
            this.subMenuActive = subMenuActive
            this.$parent.categoryName = subCategory.name
             this.$router.push({
                name: 'product', 
                query: {
                    search: subCategory.name
                }
            })
        }
    },
    mounted() {
        $(function(){
            $('.js-accordion').accordion({
                selector: {
                    trigger: '.title'
                }
            })
        })
    },
}
</script>

<style lang="scss" scoped>

</style>